"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  id: "faq-1",
  question: "What is truck dispatching and how does it work?",
  answer: "Truck dispatching connects owner-operators with freight loads. We handle rate negotiation, load booking, route planning, and paperwork so you can focus on driving and earning."
}, {
  id: "faq-2",
  question: "How much does Oryx Fleet charge for dispatching services?",
  answer: "We operate on a transparent flat-fee commission model. Contact us at (888) 218-8355 or dispatch@oryxfleet.com for pricing details tailored to your operation."
}, {
  id: "faq-3",
  question: "Do you perform broker credit checks?",
  answer: "Yes, we verify every broker's credit and payment history before booking loads, protecting you from payment delays and fraud."
}, {
  id: "faq-4",
  question: "What documents do I need to start working with Oryx Fleet?",
  answer: "You'll need your MC authority, insurance certificates, and a signed dispatcher agreement. We handle all packet management and billing documentation for you."
}, {
  id: "faq-5",
  question: "How do I get started with your dispatching service?",
  answer: "Call us toll-free at (888) 218-8355, email dispatch@oryxfleet.com, or visit our office at 30 N Gould St Ste R, Sheridan, WY 82801. We'll guide you through a quick onboarding process."
}, {
  id: "faq-6",
  question: "What makes Oryx Fleet different from other dispatch services?",
  answer: "We combine professional rate negotiation, rigorous broker vetting, comprehensive billing support, and a flat-fee pricing structure to maximize your earnings and minimize risk."
}];
export default function FAQ() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  return <section className="bg-background py-16 md:py-24">
			<div className="container mx-auto max-w-4xl px-4">
				<div ref={ref} className={`transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
					<h2 className="mb-3 text-center font-display text-3xl font-bold text-foreground md:text-4xl">
						Frequently Asked Questions
					</h2>
					<p className="mb-10 text-center text-lg text-foreground/80 md:mb-12">
						Get answers to common questions about our dispatching services.
					</p>

					<Accordion type="single" collapsible className="w-full space-y-3">
						{faqs.map((faq, i) => <AccordionItem key={faq.id} value={faq.id} data-index={i} className="rounded-md border border-border bg-background px-6 shadow-soft transition-all duration-[var(--duration-medium)] hover:shadow-medium">
								<AccordionTrigger className="text-base font-semibold text-foreground hover:text-primary hover:no-underline md:text-lg">
									{faq.question}
								</AccordionTrigger>
								<AccordionContent className="text-sm text-foreground/90 md:text-base">
									{faq.answer}
								</AccordionContent>
							</AccordionItem>)}
					</Accordion>
				</div>
			</div>
		</section>;
}